import { useState, useEffect } from "react";
import { BASE_URL } from "../env";

const EnrollTheUser = () => {
	const [success, setsucces] = useState();
	const [courses, setCourses] = useState([]);

	const [firstName, setFirstName] = useState("");
	const [emailForRegister, setEmailForRegister] = useState("");
	const [successForRegister, setsuccesForRegister] = useState("");

	const [email, setEmail] = useState();
	const [course, setcourse] = useState("");
	useEffect(() => {
		fetch(BASE_URL + "/getallCourse")
			.then((res) => res.json())
			.then((data) => {
				setCourses(data?.courses);
				console.log(data?.courses);
			});
	}, []);

	function EnrollingTheUser() {
		fetch(BASE_URL + "/EnrollCourse", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify({ email, courseid: course }),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data?.message === "sucessfully enrolled") {
					setsucces(data.message);
				}
				console.log(data.message);
			});

		// fetch()
		//fetch request aajana idhar
	}

	const RegisterTheUser = () => {
		fetch(BASE_URL + "/singleSignup", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				firstName,
				email: emailForRegister,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				setsuccesForRegister(data.message);
				// remove success message after 2 seconds
				setTimeout(() => {
					setsuccesForRegister("");
				}, 2000);
			});
	};

	return (
		<div className="text-center my-5">
			<h1>Register the User</h1>
			{successForRegister != "" ? (
				<div class="alert alert-success ">
					<strong>{successForRegister}</strong>
				</div>
			) : (
				""
			)}
			<br />

			<div className="d-flex justify-content-center flex-row gap-3">
				<input
					placeholder="Enter the name of the person"
					className="form-control"
					type="text"
					value={firstName}
					onChange={(e) => {
						setFirstName(e.target.value);
					}}
				/>
				<input
					placeholder="Email of the person"
					className="form-control"
					type="text"
					value={emailForRegister}
					onChange={(e) => {
						setEmailForRegister(e.target.value);
					}}
				/>
			</div>
			<br />
			<div>
				<button
					className="btn btn-dark text-light"
					onClick={() => {
						RegisterTheUser();
					}}
				>
					Register The user
				</button>
			</div>
			<br />
			<br />
			<br />

			<h1>Enroll any User using this Portal</h1>
			{success ? (
				<div class="alert alert-success ">
					<strong>{success}</strong>
				</div>
			) : (
				""
			)}
			<div className="d-flex justify-content-center flex-row gap-3">
				<input
					placeholder="enter the email of the person"
					className="form-control"
					type="text"
					value={email}
					onChange={(e) => {
						let email = e.target.value;
						if (typeof email === "string") {
							email = email.trim();
							email = email.toLowerCase();
							setEmail(email);
						}
					}}
				/>

				<select
					name=""
					id=""
					value={course}
					onChange={(e) => {
						setcourse(e.target.value);
					}}
				>
					<option value="">Select Course</option>
					{courses.map((val) => {
						return <option value={val?._id}>{val?.name}</option>;
					})}
					{/* <option value="FastTrack">Fast Track Course</option>
                    <option value="StandardCourse">Standard Course</option>
                    <option value="ProCourse">Pro Course</option>
                    <option value="PremiumCourse">Premium Course</option> */}
				</select>
			</div>
			<br />
			<div>
				<button
					className="btn btn-dark text-light"
					onClick={EnrollingTheUser}
				>
					Enroll The user
				</button>
			</div>
		</div>
	);
};

export default EnrollTheUser;
